var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SideFilter,{ref:"boneSideFilter",staticClass:"mt-0",attrs:{"filterList":_setup.filtersBone,"hideClear":true},on:{"input":_setup.updateFilter,"inputWeek":_setup.updateWeekFilter,"inputYear":_setup.updateYearFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }